import { render, staticRenderFns } from "./tzsdk.vue?vue&type=template&id=1070c808&scoped=true&"
import script from "./tzsdk.vue?vue&type=script&lang=js&"
export * from "./tzsdk.vue?vue&type=script&lang=js&"
import style0 from "./tzsdk.vue?vue&type=style&index=0&id=1070c808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070c808",
  null
  
)

export default component.exports